import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

export const SignaturePad = forwardRef(({ onChange }, ref) => {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = canvas.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1B2F8F";
  }, []);

  const pos = (e) => {
    const r = canvas.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    drawing.current = true;
    const ctx = canvas.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvas.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
    if (!dirty.current) {
      dirty.current = true;
      onChange?.(true);
    }
  };

  useImperativeHandle(ref, () => ({
    clear: () => {
      const c = canvas.current;
      c.getContext("2d").clearRect(0, 0, c.width, c.height);
      dirty.current = false;
      onChange?.(false);
    },
    toDataURL: () => canvas.current.toDataURL("image/png"),
    isEmpty: () => !dirty.current,
  }));

  return (
    <canvas ref={canvas} data-testid="signature-canvas"
      className="touch-none w-full h-48 rounded-lg bg-white border-2 border-dashed border-slate-400 cursor-crosshair"
      onPointerDown={down} onPointerMove={move} onPointerUp={() => (drawing.current = false)} onPointerLeave={() => (drawing.current = false)} />
  );
});
SignaturePad.displayName = "SignaturePad";
